import { bluePrimaryLink } from 'components/Globals/Base/Link/LinkStyles';
import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getBodyStyle, getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .placeholder {
    margin-bottom: 16px;
  }
`;

export const Hero = styled.div<{ theme: Theme }>`
  width: 100%;
  color: ${getColor('textPrimary')};
  font-family: ${font.graphikCond};
  background-color: ${getColor('surfaceBrand')};
  padding: 24px 20px 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 280px;

  @media (${breakpoint.mdMin}) {
    padding: 40px 32px 80px;
    min-height: 260px;
  }

  @media (${breakpoint.xlMin}) {
    padding: 40px 48px 80px;
    min-height: 250px;
  }

  a {
    ${bluePrimaryLink}
  }
`;

export const HeroTitle = styled(Heading)`
  font-weight: 600;
`;

export const HeroDescription = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;

  @media (${breakpoint.lgMin}) {
    font-size: 20px;
    line-height: 30px;
  }
`;

export const LetterPickerWrapper = styled.div`
  padding: 0 15px;
  width: 100%;

  &.loading {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const MainContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .letter-picker {
    margin: 40px 0;
  }

  .hidden {
    display: none;
    visibility: hidden;
    pointer-events: none;
  }

  @media (${breakpoint.lgMin}) {
    flex: 1;
    width: calc(100% - (266px + 40px)); // 266px from sidebar + 40px gap
  }
`;

export const CompaniesWrapper = styled.div`
  display: grid;
  grid-gap: 16px;

  @media (${breakpoint.mdMin}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 24px;
  }

  @media (${breakpoint.xlMin}) {
    grid-gap: 40px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px;
  gap: 24px;
  position: relative;
  top: -44px;

  @media (${breakpoint.mdMin}) {
    padding: 0 32px;
    top: -64px;
  }

  @media (${breakpoint.lgMin}) {
    flex-direction: row;
    gap: 24px;
    padding: 0 40px;
  }
`;

export const SidebarWrapper = styled.div`
  position: relative;
  width: 266px;
  display: none;

  @media (${breakpoint.lgMin}) {
    display: block;
  }
`;

export const Sidebar = styled.div`
  position: sticky;
  top: 68px; // height of the header
`;

export const SpinnerWrapper = styled.div`
  margin: 16px auto 0 ;

  .spinning-loader {
    margin: 16px auto 0;
  }
`;

export const ResultText = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' })};
  margin-bottom: 16px;

  &.bold {
    font-weight: bold;
  }
`;
